// Mantiene el diseño móvil al girar un teléfono, sin cambiar tabletas y escritorio.
export default function isMobileLayout() {
  if (typeof window === 'undefined') return false;
  if (window.innerWidth <= 768) return true;
  return window.innerWidth <= 1100 &&
    window.innerHeight <= 600 &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: coarse)').matches;
}
